export default __webpack_public_path__ + "static/media/fb.1bc2c1a9.svg";